<template>
  <div>
    <div class="advanceParent">
      <app-history
        @clicked="
          showPaymentDialog = true;
          fardId = 0;
          amount = 100000;
          description = '';
          searchInput = '';
          currentFard = '';
        "
        title="وارد کردن پرداخت"
        :fixsize="true"
      />
      <app-history
        v-if="selectedFardId == 0"
        title="ورود فایل"
        :fixsize="true"
        @clicked="onClickFile"
      />

      <app-history
        v-if="selectedFardId == 0"
        title="دانلود فایل نمونه"
        :fixsize="true"
        @clicked="downloadSample"
      />


      <app-history
        @clicked="showSearchDialog = true"
        title="جستجوی پیشرفته"
        class="advancedSearch"
      />
      <export-excel
        style="float: left"
        :fetch="GetDataForExcel"
        :fields="excelHeaders"
        worksheet="My Worksheet"
        name="گزارش حسابداری.xls"
      >
        <app-history class="advancedSearch" title="خروجی اکسل" />
      </export-excel>
    </div>
    <v-file-input
      v-if="selectedFardId == 0"
      accept=".xlsx"
      ref="fileInput"
      v-model="file"
      style="display: none"
      @change="handleFile"
    ></v-file-input>
    <div>
      <v-data-table
        :items="filteredUsers"
        :server-items-length="totalCount"
        :headers="paymentsHeaders"
        class="elevation-1 rounded"
        :footer-props="{
          itemsPerPageAllText: 'همه',
          itemsPerPageText: 'تعداد ردیف',
          itemsPerPageOptions: [10],
        }"
        :no-data-text="tableText"
        :header-props="$store.getters.headerProps"
        @pagination="doPage"
      >
        <template v-slot:[`item.paymentType`]="{ item }">
          {{ item.paymentType == 1 ? "ثبت دستی" : "پرداخت اینترنتی" }}
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          {{ Number(item.amount).toLocaleString() }}
        </template>
        <template v-slot:[`item.date`]="{ item }">
          {{ convertDate(item.date) }}
        </template>

        <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
          از {{ pageStart }} تا {{ pageStop }}
        </template>

        <!-- <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            class="dialogButton"
            rounded
            @click="removeItem(item)"
            v-if="item.paymentType == 1"
            >حذف</v-btn
          >
        </template> -->
      </v-data-table>
    </div>
    <v-dialog v-model="showPaymentDialog" content-class="myDialog">
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4">
          {{ "انتخاب فرد" }}
        </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            v-model="searchInput"
            maxlength="10"
            :oninput="onInput"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> </v-col>
        <v-col class="d-flex fardName" cols="12" sm="8">
          {{ currentFard }}
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> مبلغ(ریال) </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field v-model="amount" class="textLtr"></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> توضیحات </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-textarea outlined v-model="description" no-resize></v-textarea>
        </v-col>
      </v-row>

      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="applyRequest"
          :disabled="apiRunning"
        >
          ذخیره
        </v-btn>
        <v-btn class="dialogButton" rounded @click="showPaymentDialog = false">
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <v-dialog v-model="showSearchDialog" content-class="myDialog">
      <v-row align="center" v-if="selectedFardId == 0">
        <v-col class="d-flex" cols="12" sm="4">
          {{ "انتخاب فرد" }}
        </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field v-model="searchInput"></v-text-field>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> </v-col>
        <v-col class="d-flex fardName" cols="12" sm="8">
          {{ currentFard }}
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تاریخ شروع: </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            :value="StartDate"
            @click="onClickDate(1)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="4"> تاریخ پایان: </v-col>
        <v-col class="d-flex" cols="12" sm="8">
          <v-text-field
            :value="EndDate"
            @click="onClickDate(2)"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn
          color="green white--text"
          class="dialogButton"
          rounded
          @click="GetBranchPayments"
          :disabled="apiRunning"
        >
          جستجو
        </v-btn>
        <v-btn
          color="red white--text"
          class="dialogButton"
          rounded
          @click="clearFilter"
          :disabled="apiRunning"
        >
          پاک کردن
        </v-btn>
        <v-btn class="dialogButton" rounded @click="showSearchDialog = false">
          انصراف
        </v-btn>
      </v-row>
    </v-dialog>
    <date-picker
      ref="datepicker1"
      v-model="StartDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput1"
      @change="onChangeDate($event, 1)"
    ></date-picker>
    <input id="fileInput1" ref="fileInput1" />
    <date-picker
      ref="datepicker2"
      v-model="EndDate"
      :editable="false"
      :auto-submit="true"
      element="fileInput2"
      @change="onChangeDate($event, 2)"
    ></date-picker>
    <input id="fileInput2" ref="fileInput2" />
    <!-- <app-dialog @close="onCloseDialog"></app-dialog> -->
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { toArabicCharacter } from "@/utils/constants";
import {
  GetBranchPayments,
  SaveByModirPayment,
  DeletePayment,
  ImportExcel,
} from "@/api/payments";
import { FindUserByCode } from "@/api/user";
import moment from "moment-jalaali";
export default {
  components: {
    appHistory: HistoryButton,
    appDialog: Dialog,
  },
  data() {
    return {
      showPaymentDialog: false,
      showSearchDialog: false,
      payments: [],

      searchInput: "",
      fardId: 0,
      amount: 0,
      StartDate: "",
      EndDate: "",
      description: "",
      paymentType: 0,

      currentFard: "",
      file: null,
      paymentsHeaders: [
        {
          text: "شناسه",
          value: "id",
          width: "10%",
        },
        {
          text: "نام فرد",
          value: "fardName",
          width: "20%",
          sortable: false,
        },

        {
          text: "مبلغ(ریال)",
          value: "amount",
          width: "10%",
          cellClass: "cellLtr",
        },
        {
          text: "نوع",
          value: "paymentType",
          width: "10%",
        },
        {
          text: "تاریخ",
          value: "date",
          width: "20%",
          cellClass: "cellLtr",
        },
        {
          text: "توضیحات",
          value: "description",
          width: "35%",
          sortable: false,
        },
      ],
      excelHeaders: {
        شناسه: "id",
        "نام فرد": "fardName",
        "مبلغ(ریال)": {
          field: "amount",
          callback: (value) => {
            return Number(value).toLocaleString();
          },
        },
        نوع: {
          field: "paymentType",
          callback: (value) => {
            return value == 1 ? "ثبت دستی" : "پرداخت اینترنتی";
          },
        },
        تاریخ: {
          field: "date",
          callback: (value) => {
            return this.convertDate(value);
          },
        },
        توضیحات: "description",
      },

      totalCount: 0,
    };
  },
  created() {
    this.fardId = this.selectedFardId;
    if (this.currentBranch) this.GetBranchPayments();
  },
  computed: {
    selectedFardId() {
      return this.$store.getters.selectedFard.fardId;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
    onInput() {
      return "this.value=this.value.slice(0,this.maxLength)";
    },
    filteredUsers() {
      return this.payments.filter((single) => {
        return (
          /\d{10}/.test(this.searchInput) ||
          single.fardName.includes(toArabicCharacter(this.searchInput)) ||
          single.fardName.includes(this.searchInput)
        );
      });
    },
  },
  watch: {
    searchInput(value) {
      if (/\d{10}/.test(value)) {
        this.FindUser();
      } else {
        this.currentFard = "";
        this.fardId = 0;
      }
    },
    amount: function (newValue) {
      const hasMinus = newValue.toString().charAt(0) == "-";
      let result = newValue
        .toString()
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (hasMinus) {
        result = "-" + result;
      }
      Vue.nextTick(() => (this.amount = result));
    },
  },
  methods: {
    GetBranchPayments(skip) {
      if (isNaN(skip)) skip = 0;
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetBranchPayments(
          this.currentBranch.id,
          this.fardId,
          this.StartDate,
          this.EndDate,
          skip
        )
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.payments = response.data.items;
            this.totalCount = response.data.count;
            this.$store.commit("SET_TABLE_TEXT", false);
            this.showSearchDialog = false;
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async GetDataForExcel() {
      const response = await GetBranchPayments(
        this.currentBranch.id,
        this.fardId,
        this.StartDate,
        this.EndDate,
        -1
      );
      return response.data.items;
    },
    onChangeDate($event, input) {
      if (input == 1) {
        this.StartDate = $event.format("jYYYY/jMM/jDD");
      } else {
        this.EndDate = $event.format("jYYYY/jMM/jDD");
      }
    },
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    onClickFile() {
      this.$refs.fileInput.$refs.input.click();
    },
    downloadSample(){
        window.open("https://hozehkh.com/res/payment-sample-file.xlsx" );
    },
    convertDate(date) {
      return moment(date).format("jYYYY/jMM/jDD HH:mm");
    },
    handleFile() {
      var text = "";

      if (this.file == null) {
        text = "فایلی انتخاب نشده است.";
      } else if (!this.file.name.toLowerCase().endsWith(".xlsx")) {
        text = "فایل انتخابی بایستی xlsx باشد.";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        //this.$store.commit("SET_API_RUNNING", true);
        ImportExcel(this.currentBranch.id, this.file)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);
            this.$store.commit("SET_API_RUNNING", false);
            
            this.GetBranchPayments();
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
    doPage($event) {
      if (!this.showSearchDialog)
        this.GetBranchPayments(($event.page - 1) * 10);
    },
    FindUser() {
      return new Promise((resolve, reject) => {
        FindUserByCode(this.searchInput)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            const data = response.data.data;
            this.fardId = data.fardID;
            this.currentFard =
              data.fardID != 0
                ? data.name + " " + data.family
                : "موردی یافت نشد.";

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    clearFilter() {
      if (this.selectedFardId == 0) {
        this.fardId = 0;
        this.currentFard = "";
        this.searchInput = "";
      }

      this.StartDate = "";
      this.EndDate = "";
      this.GetBranchPayments();
    },
    applyRequest() {
      var text = "";
      this.amount = this.amount.replace(/,/g, "");
      const amount = parseInt(this.amount);
      if (this.fardId == 0) {
        text = "فرد بایستی انتخاب شود.";
      } else if (isNaN(amount) || amount == 0 || amount != this.amount) {
        text = "مبلغ بابستی یک عدد صحیح مثبت یا منفی باشد";
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        //this.$store.commit("SET_API_RUNNING", true);
        SaveByModirPayment(
          this.currentBranch.id,
          this.fardId,
          this.amount,
          this.description
        )
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.message);
            this.$store.commit("SET_API_RUNNING", false);
            this.showPaymentDialog = false;
            this.GetBranchPayments();
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
  },
};
</script>
<style >
.text-start.cellLtr {
  direction: ltr;
  text-align: end !important;
}

.textLtr input {
  direction: ltr;
  text-align: right;
}

.filterButton {
  width: 100%;
}
</style>
